var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mx-auto",class:[_vm.spacingTop, _vm.spacingBottom, _vm.oddRows]},[_c('div',{staticClass:"table"},_vm._l((_vm.table),function(row,i){return _c('Row',{key:row.id,attrs:{"index":i,"cols":row}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }